import "./button.scss";
import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "react-bootstrap";
import Typography from "../../Typography";

const Button = ({
  text,
  type,
  size, // xs, sm, md, lg, xl
  variant, // primary, secondary, danger, plain
  isPlain,
  disabled,
  dataTour,
  leftIcon,
  rightIcon,
  fullWidth,
  handleClick,
  customClass,
  isSubmitting,
  isNewTag,
  newTagText,
  countTag,
  customStyles,
  ...props
}) => (
  <button
    type={type}
    disabled={disabled}
    data-tour={dataTour}
    onClick={handleClick}
    className={`sb-button sb-button--${size} ${
      fullWidth ? "sb-button--full-width" : ""
    } sb-button--${variant}${isPlain ? "--plain" : ""}${
      customClass ? ` ${customClass}` : ""
    }`}
    {...props}
    style={{ ...customStyles }}
  >
    {leftIcon ? (
      <>
        {typeof leftIcon === "string" ? (
          <img height="16px" width="16px" src={leftIcon} alt="btn-icon" />
        ) : (
          leftIcon
        )}
      </>
    ) : (
      <></>
    )}
    {text?.length > 0 ? <span className="button-text">{text}</span> : <></>}
    {type === "submit" && isSubmitting ? (
      <Spinner
        as="div"
        size="sm"
        role="status"
        animation="border"
        aria-hidden="true"
      />
    ) : rightIcon ? (
      <>
        {typeof rightIcon === "string" ? (
          <img height="16px" width="16px" src={rightIcon} alt="btn-icon" />
        ) : (
          rightIcon
        )}
      </>
    ) : isNewTag ? (
      <Typography
        tag="span"
        size="text-xs"
        weight="medium"
        customClass={ "new-tag" }
      >
        {newTagText || "NEW"}
      </Typography>
    ) : countTag > 0 ? (
      <Typography
        tag="span"
        size="text-xs"
        weight="medium"
        customClass="count-tag"
      >
        {countTag}
      </Typography>
    ) : (
      <></>
    )}
  </button>
);

export default Button;

Button.propTypes = {
  text: PropTypes.string,
  isPlain: PropTypes.bool,
  disabled: PropTypes.bool,
  isNewTag: PropTypes.bool,
  fullWidth: PropTypes.bool,
  countTag: PropTypes.number,
  dataTour: PropTypes.string,
  handleClick: PropTypes.func,
  isSubmitting: PropTypes.bool,
  customClass: PropTypes.string,
  leftIcon: PropTypes.node || PropTypes.string,
  rightIcon: PropTypes.node || PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]), // button, submit, reset
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "danger-secondary",
    "secondary-gradient",
  ]),
};

Button.defaultProps = {
  size: "sm",
  type: "button",
  disabled: false,
  fullWidth: false,
  variant: "primary",
  isNewTag: false,
  countTag: 0,
};
